export const server = process.env.REACT_APP_SERVER

if (typeof server === 'undefined') {
    throw 'REACT_APP_SERVER missing in process.env'
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/BuildEnvironment.ts